import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/callcenter/CallCenter.vue'),
		meta: {
			title: 'callcenter',
			acl: 'section.callcenter'
		}
	}
];

export default routes;